import { useContext, useEffect, useState } from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import { useQuery, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { getAll, updateActive } from "./services/api";
import { SnackbarGlobal } from "components/Snackbar";
import { StyledMenu } from "components/Styled";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";
import { ActionFabButtonAdd, ActionsDialogPage, ActionsMUIRowRender, ActionsMenuPage } from "./ActionsPage";
import { MUIColumns, getActive, handleSetInstance } from "./routeHelpers";
import LoaderTable from "components/Loaders/LoaderTable";
import MUIDataTable from "mui-datatables";
import { MUIDataTableGlobalOptions, ReactQueryMutationFunctionHG } from "helpers";
import { AuthContext } from "context/AuthContext";
import { BranchOfficeSelect, BranchOfficeSelectOnPage } from "components/BranchOfficesSelect/BranchOfficeSelect";

export default function Menu() {
  const { t } = useTranslation();
  const { branchOfficeSelected } = useContext(AuthContext)
  const [loadingUpdateActive, setLoadingUpdateActive] = useState(false)
  const [itemId, setItemId] = useState(null)
  const [dataFilter, setDataFilter] = useState(null)
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete, 4: view
  const [notification, setNotification] = useState({ open: false, message: "", severity: "info" })
  const [instanceSelected, setInstanceSelected] = useState({})
  const [changeBranchOffice, setChangeBranchOffice] = useState(false)
  const queryClient = useQueryClient()
  const { dataUpdatedAt, data } = useQuery('menusList', getAll, { refetchOnWindowFocus: false })

  useEffect(() => {
    queryClient.invalidateQueries('menusList')
    setChangeBranchOffice(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchOfficeSelected])

  useEffect(() => {
    if (data !== undefined && data !== null && data !== "") {
      setDataFilter(data.menus)
      setLoadingUpdateActive(false)
      setItemId(null)
      setChangeBranchOffice(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdatedAt])

  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { setOpenAction(0); queryClient.invalidateQueries('menusList') }
  }

  const mutation = ReactQueryMutationFunctionHG(updateActive, handleWatchAction)
  const handleUpdateActive = (id) => {
    setLoadingUpdateActive(true)
    setItemId(id)
    const active = getActive(id, data)
    mutation.mutate({ id: id, params: { active: !active } })
  }

  const [anchorElMenuActions, setAnchorElMenuActions] = useState(null)
  const open = Boolean(anchorElMenuActions)
  const handleClickMenuActions = (event, value) => {
    setAnchorElMenuActions(event.currentTarget); handleSetInstance(value, data, setInstanceSelected);
  }
  const handleCloseMenuActions = () => { setAnchorElMenuActions(null) }

  const handleMenuItemClick = (option) => { setOpenAction(option); handleCloseMenuActions(); }

  const columns = MUIColumns(t, (value, tableMeta, updateValue) => {
    return <ActionsMUIRowRender
      value={value}
      data={data}
      actionClickMenu={handleClickMenuActions}
      loadingUpdateActive={loadingUpdateActive}
      itemId={itemId}
      getActive={getActive}
      actionUpdateActive={handleUpdateActive} />
  })

  if (branchOfficeSelected === null) { return <BranchOfficeSelectOnPage /> }

  return (<>
    <FMPageOpacityTransition>
      {branchOfficeSelected !== null ? <>
        <Box component="div" style={{ marginBottom: 100 }}>
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            {(dataFilter !== null && !changeBranchOffice) ?
              <MUIDataTable data={dataFilter} columns={columns} options={MUIDataTableGlobalOptions(t)} />
              : <Paper sx={{ padding: 3 }}> <LoaderTable /> </Paper>
            }
          </Container>
        </Box>
        <ActionFabButtonAdd t={t} action={() => setOpenAction(1)} />
        <ActionsDialogPage
          open={openAction}
          close={() => setOpenAction(0)}
          instance={instanceSelected}
          reportAction={handleWatchAction} />
      </> : null}
    </FMPageOpacityTransition>
    <StyledMenu id="demo-customized-menu"
      anchorEl={anchorElMenuActions}
      open={open}
      onClose={handleCloseMenuActions}
      MenuListProps={{ 'aria-labelledby': 'demo-customized-button' }}>
      <ActionsMenuPage t={t} action={handleMenuItemClick} />
    </StyledMenu>
    <SnackbarGlobal
      open={notification.open}
      close={() => setNotification({ ...notification, open: false, message: "" })}
      message={notification.message}
      severity={notification.severity} />
  </>)
}